import React, { Component, Fragment } from 'react'
import * as R from 'ramda'
import Input from 'components/fulcrum/input/Input'
import Dropdown from 'components/fulcrum/dropdown/FulcrumDropdown'
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
} from 'react-toolbox'
import CSSModules from 'react-css-modules'
import styles from './styles.scss'

import T from 'i18n-react'

class MultiFieldSimple extends Component {
  handleChange(index, type, val) {
    this.props.onChange(index, type, val)
  }

  getTableHead = () =>  {
    const { rowFormat, elementKey } = this.props

    return (
      <TableHead>
        {
          Object.keys(rowFormat).map((header, idx) => {
            return(
              <TableCell key={idx}>
                {T.translate(`project.spec.${elementKey}.item.${header}`)}
              </TableCell>
            )
          })
        }
      </TableHead>
    )
  }

  renderRows = () => {
    const { elementKey, values, rowFormat } = this.props
    return (
      <TableRow key={elementKey}>
        {
          Object.keys(rowFormat).map((key, idx) => {
            const {type, sources} = rowFormat[key]
            let val = []
            if (values[0]) {
              val = values[0][key]
            }
            switch(type) {
              case 'string': return (
                <TableCell key={idx}>
                  <Input type='text' value={val} onChange={this.handleChange.bind(this, 0, key )}/>
                </TableCell>
              )
              case 'number': return (
                <TableCell key={idx}>
                  <Input type='number' value={val} onChange={this.handleChange.bind(this, 0, key )}/>
                </TableCell>
              )
              case 'drop_down': return (
                <TableCell key={idx}>
                  <Dropdown source={sources} value={val} onChange={this.handleChange.bind(this, 0, key )}/>
                </TableCell>
              )
            }
          })
          }
      </TableRow>
    )
  }
  render() {
    return (
      <Fragment >
        <h4 styleName='multiFieldSimpleTitle'>{T.translate(this.props.title)}</h4>
      <Table 
        selectable={false}
      >
        {this.getTableHead()}
        {this.renderRows()}
      </Table>
    </Fragment>
    )
  }
}

export default CSSModules(MultiFieldSimple, styles)
